import React from "react";

import DatePicker, { registerLocale } from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import pt from "date-fns/locale/pt";
registerLocale("pt", pt);

export default function InputDatePickerMesAno(props) {
    return (
        <DatePicker
            className="form-control text-md-right"
            dateFormat={"MM/yyyy"}
            showMonthYearPicker
            showFullMonthYearPicker
            locale={"pt"}
            {...props}
        >
        </DatePicker>
    );
}